import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { generatePath, Link } from 'react-router'

import { Descriptions } from 'antd'

import routes, { generateSlug } from '../../routes'

import { Description } from './Description'

const FamilyMembers: FC<{ data?: Maybe<Maybe<FamilyMemberFragment>[]> }> = ({ data = [] }) => {
  if (data?.length === 0) return null

  return (
    <Description titleId={'rider.family-member'}>
      <Descriptions
        size={'small'}
        column={1}
        items={data?.map((it) => ({
          label: (
            <FormattedMessage
              id={['rider', 'family-member', it?.relationship.replace(/_/g, '-').toLowerCase()].join('.')}
            />
          ),
          children: (
            <Link to={generatePath(routes.rider, { slug: generateSlug(it?.rider?.slug) })}>{it?.rider?.name}</Link>
          ),
        }))}
      />
    </Description>
  )
}

export { FamilyMembers }
